<!-- results-table.component.html -->
<h1 mat-dialog-title><strong>{{action}}</strong> la evaluación {{LOCAL_DATA.nombre}}?</h1>
<div mat-dialog-content>
      <mat-form-field *ngIf="action == 'Copiar'" class="select-list">
        <input placeholder="Nombre" matInput [(ngModel)]="nombre">
      </mat-form-field>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="doAction()">Aceptar</button>
  <button mat-button (click)="closeDialog()" mat-flat-button color="warn">{{'Cancel' | translate}}</button>
</div>
